import { HttpClient } from '@angular/common/http';
import {
  TRANSLOCO_LOADER,
  Translation,
  TranslocoLoader,
  TRANSLOCO_CONFIG,
  translocoConfig,
  TranslocoModule,
  getBrowserLang
} from '@ngneat/transloco';
import { Injectable, isDevMode, NgModule } from '@angular/core';
import { AvailableLanguages } from 'src/assets/i18n/available-languages';

// Function to get the default language, prioritizing stored preference
function getDefaultLang(): string {
  const storedLang = localStorage.getItem('LOYAL_LANG');
  if (storedLang && AvailableLanguages.some(e => e.lang === storedLang)) {
    return storedLang;
  }
  return 'hr'; // Default to Croatian if no preference found
}

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

// import only translate in ts file, no need for the whole service

//scope for lazy loaded modules
// providers: [{ provide: TRANSLOCO_SCOPE, useBalue: 'name' }] inside module.ts file

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: ['hr', 'en'],
        defaultLang: getDefaultLang(),
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      }),
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
  ],
})
export class TranslocoRootModule {}
